const rankingItems = [
  { rank: 1, title: '顶流男星深夜密会神秘女子全记录', hot: '🔥 128万', change: 'up', tag: '新' },
  { rank: 2, title: '知名企业家公开言论引发全网大讨论', hot: '🔥 120万', change: 'up', tag: '热' },
  { rank: 3, title: '综艺录制现场激烈争执名场面', hot: '🔥 112万', change: 'up', tag: '爆' },
  { rank: 4, title: '多部热剧同期开播收视率大战', hot: '88万', change: 'down', tag: '' },
  { rank: 5, title: '网红直播带货翻车遭平台处罚', hot: '76万', change: 'up', tag: '' },
  { rank: 6, title: '热门综艺收视率再创新高引热议', hot: '65万', change: 'same', tag: '' },
  { rank: 7, title: '吃瓜大赛总决赛精彩回顾合集', hot: '54万', change: 'up', tag: '' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            🏆 吃瓜热榜
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            实时热度排行，看看全网瓜友都在关注什么
          </p>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden">
          {rankingItems.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              onClick={(e) => e.preventDefault()}
              className={`flex items-center gap-4 px-5 py-4 transition-colors duration-200 cursor-pointer hover:bg-background-100 ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold ${
                item.rank === 1 ? 'bg-primary-500 text-white' :
                item.rank === 2 ? 'bg-accent-500 text-white' :
                item.rank === 3 ? 'bg-secondary-500 text-white' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-foreground-900 truncate">{item.title}</span>
                  {item.tag && (
                    <span className={`flex-shrink-0 px-1.5 py-0.5 text-[10px] font-bold rounded ${
                      item.tag === '爆' ? 'bg-primary-500 text-white' :
                      item.tag === '热' ? 'bg-accent-500 text-white' :
                      'bg-secondary-500 text-white'
                    }`}>{item.tag}</span>
                  )}
                </div>
              </div>
              <div className="flex-shrink-0 flex items-center gap-1.5">
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.hot}</span>
                <span className="text-xs">
                  {item.change === 'up' && <i className="ri-arrow-up-line text-green-500"></i>}
                  {item.change === 'down' && <i className="ri-arrow-down-line text-red-500"></i>}
                  {item.change === 'same' && <i className="ri-subtract-line text-foreground-400"></i>}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}